import baseRequest from "../_core/baseRequest";
const namingRules = {};

export default {
    getCourierList: params => baseRequest.post("/courier/list", params),
    getCourier: params => baseRequest.get(`/courier/${params.courierId}`),
    getDedicationList: params => baseRequest.post("/courier/dedicationlist", params),
    createCourier: params => baseRequest.post("/courier", params),
    createCourierCandidate: params => baseRequest.post("/courier/candidate", params),
    updateCourier: params => baseRequest.put(`/courier/${params.courier._id}`, params),
    uploadImage: params => baseRequest.uploadFile("courier/uploadimage", params),
    updateStatus: params => baseRequest.put("/courier/status", params),
    updateCourierDocumentStatus: params => baseRequest.put("/courier/documents/approval", params),
    createCourierCallRecords: params => baseRequest.post("/courier/call-records", params),
    updateCourierCallRecords: params =>
        baseRequest.put(`/courier/call-records/${params.callRecordId}`, params),
    getCourierCallStatuses: params => baseRequest.get("/courier/call-statuses", params),
    getOnboardingDocumentCount: params =>
        baseRequest.get("/courier/getOnboardingDocumentCount", params),
    /* 
    will be removed on backend
    createCourierEquipmentRequests: params =>
        baseRequest.post("/courier/equipment-requests", params), */
    rejectOnboardingDocumentVerificationStatus: params =>
        baseRequest.put("/courier/onboarding/reject-documents-verification", params),
    completeTrainingPhase: params =>
        baseRequest.put("/courier/onboarding/complete-training-phase", params),
    completeShiftWaitingPhase: params =>
        baseRequest.put("/courier/onboarding/complete-shift-waiting-phase", params),
    completeOnboardingDocumentPhase: params =>
        baseRequest.put("/courier/onboarding/complete-document-phase", params),
    blockCourier: params => baseRequest.put("/courier/onboarding/block-courier", params),
    unblockCourier: params => baseRequest.put("/courier/onboarding/unblock-courier", params),
    rejectCourierApplication: params =>
        baseRequest.put("/courier/onboarding/reject-courier", params),
    undoCourierRejection: params =>
        baseRequest.put("/courier/onboarding/undo-courier-rejection", params),
    getDocumentsProgress: params =>
        baseRequest.get(`/courier/onboarding/documents-progress/${params.courierId}`),
    getCourierDocumentsRejectHistory: params =>
        baseRequest.get(
            `/courier/onboarding/documents-reject-history/${params.courierId}?${
                params.documentType ? `documentType=${params.documentType}` : ""
            }`
        ),
    getCourierDocumentsHistory: params => {
        const {courierId, documentType, skip, limit} = params;
        const queryParams = [];
        if (documentType) queryParams.push(`documentType=${documentType}`);
        if (skip !== undefined) queryParams.push(`skip=${skip}`);
        if (limit !== undefined) queryParams.push(`limit=${limit}`);
        return baseRequest.get(
            `/courier/onboarding/documents-history/${courierId}${
                queryParams.length ? `?${queryParams.join("&")}` : ""
            }`
        );
    },
    getCourierDocumentRejectionCounts: params =>
        baseRequest.get(
            `/courier/onboarding/documents-history/${params.courierId}/rejected-counts`
        ),

    changePassword: params => baseRequest.put("/courier/password", params),
    getCourierMapList: params => baseRequest.post("/courier/maplist", params),
    getCourierStatusLogs: params => baseRequest.post(`/courier/log/${params.courierId}`, params),
    uploadCourierFile: params => baseRequest.uploadFile("courier/uploadfile", params),
    getPoolCouriers: params =>
        baseRequest.get(`/courier/pool` + baseRequest.queryString(params, namingRules)),
    getCouriersOfCompany: params =>
        baseRequest.get(`/courier/dedicate` + baseRequest.queryString(params, namingRules)),
    courierDedicationLog: params => {
        const {courierId, skip, limit} = params;
        let url = `/courier/dedication-log/${courierId}`;
        const queryParams = [];
        if (skip !== undefined) queryParams.push(`skip=${skip}`);
        if (limit !== undefined) queryParams.push(`limit=${limit}`);
        if (queryParams.length > 0) {
            url += `?${queryParams.join("&")}`;
        }
        return baseRequest.get(url);
    },
    getCourierOnboardingStatusLogs: params => {
        const {courierId, skip, limit} = params;
        let url = `/courier/onboarding-status-logs/${courierId}`;
        const queryParams = [];
        if (skip !== undefined) queryParams.push(`skip=${skip}`);
        if (limit !== undefined) queryParams.push(`limit=${limit}`);
        if (queryParams.length > 0) {
            url += `?${queryParams.join("&")}`;
        }
        return baseRequest.get(url);
    },
    dedicateCompanyCouriers: params => baseRequest.post("/courier/dedicate", params),
    getMultipleSelectCities: params =>
        baseRequest.get(
            `/company/sub?offset=${params.offset}${params.companyId &&
                "&companyId=" + params.companyId}&limit=${params.limit}&city=${params.city}&`
        ),
    getMultipleSelectCompanies: params =>
        baseRequest.get(
            `/company/sub?offset=${params.offset}${params.companyId &&
                "&companyId=" + params.companyId}&limit=${params.limit}&city=${params.city}&`
        ),

    getMultipleSelectSubCompanies: params =>
        baseRequest.get(
            `/company/sub?offset=${params.offset}${params.companyId &&
                "&companyId=" + params.companyId}&limit=${params.limit}&city=${params.city}`
        ),

    courierUpdateDedication: params => baseRequest.post("/courier/updatededication", params),
    updateAllCouriersDisable: params => baseRequest.post("/courier/disable", params),
    getDeliveryLocations: params => baseRequest.post("/courier/getlocationsofdelivery", params),
    getCurrentDelivery: params => baseRequest.get(`/courier/currentDelivery/${params.courierId}`),
    getSlotCouriers: params =>
        baseRequest.get(`/courier/slot-couriers?companyId=${params.companyId}`),
    getCourierByTckn: params =>
        baseRequest.get(`/courier/courier-by-tckn/${params.courierTckn}`, params),
    getAvailableCouriersForPreferredCourier: (params, allCityCouriers) =>
        baseRequest.get(
            `/courier/available-courier-by-subcompany/${params.subCompanyId}?courierType=${
                params.courierType
            }${params?.strict ? `&strict=${params.strict}` : ""}${
                allCityCouriers ? `&allCityCouriers=${allCityCouriers}` : ""
            }${params.allPoolCouriers ? `&allPoolCouriers=${params.allPoolCouriers}` : ""}`
        ),
    listAvailableCouriers: params =>
        baseRequest.get(
            `/courier/couriers-by-subcompany/${params.subCompanyId}?${
                params?.courierType ? `courierType=${params.courierType}` : ""
            }${params?.distance ? `&distance=${params.distance}` : ""}${
                params.availableCouriersPage
                    ? `&availableCouriersPage=${params.availableCouriersPage}`
                    : ""
            }`
        ),
    getCourierHomeLocation: params => baseRequest.post("/courier/location", params),
    getCourierShifts: params =>
        baseRequest.get(
            `/courier/shifts/${params.courierId}?${
                params.startDate ? `startDate=${params.startDate}` : ""
            }${params.endDate ? `&endDate=${params.endDate}` : ""}`,
            params
        ),
    getDedicatedCourier: params =>
        baseRequest.get(
            `/courier/dedicated-couriers/${params.companyId}/${params.subCompanyId}`,
            params
        ),
    updateShiftSuggestionOptions: params =>
        baseRequest.post("/courier/shift-suggestion-options", params),
    updateCourierTransferCenter: params =>
        baseRequest.put(`/courier/dedicated-transfer-centers/${params.courierId}`, params),
    getCourierTerminals: params => baseRequest.post("/courier/list-terminals", params),
    updateCourierTerminal: params => baseRequest.post("/courier/update-terminal", params),
    getCourierInfo: params => baseRequest.get(`/courier/courier-info/${params.courierId}`),
    getCustomerMapList: params => baseRequest.post("/courier/customer-maplist", params),
    listMotorTypes: params => baseRequest.get("/courier/motor-types", params),
    listWorkingModels: params =>
        baseRequest.get(
            `/courier/listWorkingModels?${params?.isActive ? `isActive=${params.isActive}` : ""}`
        ),
    listDrivingLicenseTypes: params => baseRequest.get("/courier/driving-license-types", params),
    deactivateCourierWallet: (courierId, data) => {
        return baseRequest.post(`/wallet/courier/${courierId}/deactivate-wallet`, data);
    },
    activateCourierWallet: (courierId, data) => {
        return baseRequest.post(`/wallet/courier/${courierId}/activate-wallet`, data);
    },
    getCourierDeviceInfoHistory: params => {
        return baseRequest.get(
            `/courier/device-info-history${baseRequest.queryString(params, namingRules)}`
        );
    },
    downloadDocument: (courierId, documentType) =>
        baseRequest.get(`/courier/${courierId}/downloadDocument/${documentType}`),
    downloadAllDocuments: courierId =>
        baseRequest.get(`/courier/${courierId}/downloadAllDocuments`),
    createGetirImageWebhook: params =>
        baseRequest.post("/courier/create-getir-image-webhook", params),
    sendCourierToAccounting: courierId =>
        baseRequest.post(`/courier/${courierId}/send-to-accounting`, {}),
    getCourierNotifications: (courierId, params) => {
        const queryParams = new URLSearchParams(params).toString();
        return baseRequest.get(`/courier/${courierId}/notifications?${queryParams}`);
    },
    sendTestNotification: courierId =>
        baseRequest.post(`/courier/${courierId}/notifications/test`, {}),

    sendToEvaluation: (courierId, formData) =>
        baseRequest.put(`/courier/${courierId}/send-to-evaluation`, formData),
    cancelEvaluation: courierId => baseRequest.put(`/courier/${courierId}/cancel-evaluation`, {}),
    cancelEvaluation: courierId => baseRequest.put(`/courier/${courierId}/cancel-evaluation`, {}),
    sendToTermination: courierId =>
        baseRequest.put(`/courier/${courierId}/send-to-termination`, {}),
    terminateCourier: (courierId, formData) =>
        baseRequest.put(`/courier/${courierId}/terminate`, formData),
    startLeave: (courierId, {startDate, endDate, reason}) =>
        baseRequest.put(`/courier/${courierId}/start-leave`, {startDate, endDate, reason}),
    endLeave: courierId => baseRequest.put(`/courier/${courierId}/end-leave`, {}),
    getLeaveHistory: courierId => baseRequest.get(`/courier/${courierId}/leave-history`),
    checkCourierProviderCompany: (courierId, body) =>
        baseRequest.post(`/courier/${courierId}/provider-company/check`, body),
    updateCourierProviderCompany: (courierId, body) =>
        baseRequest.put(`/courier/${courierId}/provider-company`, body),
    getCourierReportColumns: () => baseRequest.get("/courier/report/report-columns"),
    sendAnnouncementToFilteredCouriers: params =>
        baseRequest.post("/courier/notifications/announcement", params),
    sendWhatsappToFilteredCouriers: params =>
        baseRequest.post("/courier/whatsapp/announcement", params),
    sendAnnouncementWithExcel: formData =>
        baseRequest.post("/courier/notifications/announcement/excel", formData, true),
    sendWhatsappAnnouncementWithExcel: formData =>
        baseRequest.post("/courier/whatsapp/announcement/excel", formData, true)
};
